/**
 * AlmadarPostWelcomeToAlmadarSLAlmadarPostWelcomeToAlmadarSLPage
 *
 * Page component for AlmadarPostWelcomeToAlmadarSLAlmadarPostWelcomeToAlmadarSLPage
 * Path: /sl/blog/welcome-to-almadar
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWelcomeToAlmadarSLPostPageView as __AlmadarPostWelcomeToAlmadarSLPostPageView } from '@/components/traits/AlmadarPostWelcomeToAlmadarSLPostPageView';
import { AlmadarPostWelcomeToAlmadarSLPostAnalyticsView as __AlmadarPostWelcomeToAlmadarSLPostAnalyticsView } from '@/components/traits/AlmadarPostWelcomeToAlmadarSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWelcomeToAlmadarSLAlmadarPostWelcomeToAlmadarSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostWelcomeToAlmadarSLAlmadarPostWelcomeToAlmadarSLPage(_props: AlmadarPostWelcomeToAlmadarSLAlmadarPostWelcomeToAlmadarSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWelcomeToAlmadarSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWelcomeToAlmadarSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWelcomeToAlmadarSLAlmadarPostWelcomeToAlmadarSLPage;
